import { DateRange } from './date';

export class Requestedpayments {
    id: number;
    code: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}

export class RequestedSearch {
    createdDate: DateRange = DateRange.empty();
    id = '';
    merchantId='';
    locationId:any;
    paymentId='';
    paymentMethod='';
    name ='';
    startDate = '';
    endDate = '';
    customerName='';
    phoneNumber='';
    email='';
    isSettled:any;
    accountType:any;
    status = '';
    isAvailable:boolean;
  hashId: any;
 }